import React from 'react';
import { TextBox } from 'devextreme-react/text-box';
import { Validator, RequiredRule, PatternRule } from 'devextreme-react/validator';

export interface PhoneInputProps {
    id: string;
    value: string;
    required: boolean;
    onChange: (phone: string | null | undefined) => void;
    disabled: boolean;
}

export const PhoneInput: React.FC<PhoneInputProps> = ({ id, value, required = false, onChange, disabled = false }) => {
    const phonePattern = /^\(\d{3}\) \d{3}-\d{4}$/;

    const onValueChanged = (e) => {
        if (!e.value || e.value.replace('(', '').replace(')', '').replace('-', '').trim() === '') {
            onChange && onChange(null);
        } else {
            onChange && onChange(e.value);
        }
    };

    return (
        <TextBox
            id={id}
            value={value}
            maxLength={14}
            mask='(000) 000-0000'
            maskChar='_'
            onValueChanged={onValueChanged}
            showClearButton={false}
            useMaskedValue={true}
            maskInvalidMessage='Phone # is invalid'
            validationMessageMode='always'
            valueChangeEvent='input'
            disabled={disabled}
        >
            <Validator>
                {required && <RequiredRule message='Phone # is required' />}
                <PatternRule
                    message='The phone must have a correct USA phone format'
                    pattern={phonePattern}
                />
            </Validator>
        </TextBox>
    );
};
